module.exports = __webpack_public_path__ + "img/5_cover1.003bd031.png";